import { IonCheckbox, IonFooter, IonModal, IonText } from "@ionic/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { usePostHog } from "posthog-js/react";
import { Button } from "@/components/Global/Button";
import { useSelectorModalStore } from "@/lib/store/modal";

export function ModalFriendCheckAnalysisConfirm() {
	const { t } = useTranslation();
	const modalRef = useRef<HTMLIonModalElement>(null);
	const modal = useSelectorModalStore.use.friendCheckAnalysisConfirm();
	const present = useSelectorModalStore.use.present();
	const dismiss = useSelectorModalStore.use.dismiss();
	const posthog = usePostHog();

	return (
		<IonModal
			ref={modalRef}
			isOpen={modal.isOpen}
			onWillPresent={() => {
				present("friendCheckAnalysisConfirm");
				posthog.capture("Modal FriendCheck Analysis Confirm Present");
			}}
			onWillDismiss={() => {
				dismiss("friendCheckAnalysisConfirm", {
					newCoreValues: [],
				});
				posthog.capture("Modal FriendCheck Analysis Confirm Dismiss");
			}}
			initialBreakpoint={1}
			breakpoints={[0, 1]}
			className="ion-min-h-[600px] ion-rounded-4xl ion-h-min"
		>
			<div className="space-y-8 p-4 pt-8">
				<div className="flex flex-col justify-center gap-2">
					<IonText className="text-brown-700 text-2xl font-bold">
						{t("modal.friend-check.analysis.confirm.title")}
					</IonText>
					<IonText className="text-brown-600">
						{t("modal.friend-check.analysis.confirm.description")}
					</IonText>
				</div>
				<div className="flex flex-col justify-center gap-2">
					{modal.newCoreValues?.map((coreValue, index) => (
						<IonCheckbox
							key={index}
							data-attr="modal.friend-check.analysis.generate.core-value"
							className="bg-brown-100 part-[label]:flex part-[label]:flex-1 part-[label]:items-center part-[label]:justify-between part-[label]:gap-2 part-container:opacity-100 flex-1 rounded-xl p-3 opacity-100"
							checked
							disabled
							value={coreValue?.name}
						>
							<span className="text-brown-700 flex flex-row items-center gap-2 font-semibold">
								<IonText className="block min-w-5 text-center">{coreValue.emoji}</IonText>
								<IonText>{coreValue.name}</IonText>
							</span>
						</IonCheckbox>
					))}
				</div>
			</div>
			<IonFooter className="ion-padding">
				<Button
					onClick={() => {
						posthog.capture("Modal FriendCheck Analysis Confirm Finished");
						modal.onConfirmed?.();
						dismiss("friendCheckAnalysisConfirm", { newCoreValues: [] });
					}}
					className="w-full"
					expand="block"
				>
					{t("modal.friend-check.analysis.confirm.actions.confirm")}
				</Button>
				<Button
					className="w-full"
					expand="block"
					variant="link"
					onClick={() => {
						dismiss("friendCheckAnalysisConfirm", { newCoreValues: [] });
					}}
				>
					{t("modal.friend-check.analysis.confirm.actions.dismiss")}
				</Button>
			</IonFooter>
		</IonModal>
	);
}
